// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .wrapper--dxUKM {
  margin-top: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/TooManySelectionsPlaceholder/styles.css"],"names":[],"mappings":"AAGA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n}\n\n.wrapper {\n  margin-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper--dxUKM`
};
export default ___CSS_LOADER_EXPORT___;
